export default __webpack_public_path__ + "static/media/reject.99aa229b.svg";